module.exports = __webpack_public_path__ + "img/icon_google.1924543d.svg";